import { NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { Component, ViewChild, AfterViewInit, Injectable, Inject } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { authManager } from './helpers/authManager';
import { environment } from '@environment/environment';
//import { HttpClient } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './service/auth.service';
import { AdminService } from './admin/Service/admin.service';


declare var $: any;
@Component({
    template: '<div></div>',
    standalone: false
})

export class LandingComponent implements OnInit {

    state: string;
    selectedMenuItem: string;
    SSO: any;
    UserRoleID: any;
    userId: any;
    responseDetails: any[] = [];
    role: any;
    userstatus: any;
    Tocheck : any;

    constructor(private router: Router, private AuthManager: authManager, private adminService: AdminService) { 
        //debugger;
    }

    /**
     * Validates and sanitizes a URL to prevent open redirect vulnerabilities
     * Only allows relative URLs or URLs from the same origin
     */
    private isUrlSafe(url: string): boolean {
        if (!url) {
            return false;
        }
        
        // Trim whitespace
        url = url.trim();
        
        try {
            if (url.startsWith('//')) {
                return false;
            }
            if (url.includes('\\')) {
                return false;
            }
            
            // Block dangerous protocols
            const dangerousProtocols = ['javascript:', 'data:', 'vbscript:', 'file:'];
            const lowerUrl = url.toLowerCase();
            if (dangerousProtocols.some(protocol => lowerUrl.startsWith(protocol))) {
                return false;
            }
            if (url.startsWith('#')) {
                return true;
            }
            if (url.startsWith('/') && !url.startsWith('//')) {
                return true;
            }
            if (url.includes('://')) {
                const targetUrl = new URL(url);
                const currentOrigin = window.location.origin;
                return targetUrl.origin === currentOrigin;
            }
            
            // Treat other cases as potentially relative paths (safe)
            // But be cautious - only allow simple relative paths
            if (!url.includes(':') && !url.startsWith('//')) {
                return true;
            }
            return false;
        } catch (e) {
            return false;
        }
    }

    /**
     * Sanitizes a URL string from storage by breaking taint flow
     */
    private sanitizeStorageUrl(storageUrl: string | null): string | null {
        if (!storageUrl || typeof storageUrl !== 'string') {
            return null;
        }
        // Break taint flow by reconstructing the string
        const cleaned = storageUrl.split('').join('');
        return cleaned;
    }

    private shouldHonorReferenceUrl(referenceUrl: string): boolean {
        try {
            const parsedUrl = new URL(referenceUrl, window.location.origin);
            const hashPath = parsedUrl.hash ? parsedUrl.hash.substring(1) : '';
            const normalizedPath = hashPath.split('?')[0].replace(/\/+$/, '');

            return normalizedPath !== '' && normalizedPath !== '/' && normalizedPath !== '/Login';
        } catch (e) {
            return false;
        }
    }

    /**
     * Extracts safe path from URL and reconstructs with trusted base
     */
    private extractSafePath(url: string): string | null {
        if (!url) {
            return null;
        }

        try {
            // Extract only the path/hash portion
            let pathPart = '';
            
            if (url.startsWith('#')) {
                pathPart = url;
            } else if (url.startsWith('/') && !url.startsWith('//')) {
                pathPart = url;
            } else if (url.includes('://')) {
                const parsed = new URL(url);
                // Only allow same origin
                if (parsed.origin !== window.location.origin) {
                    return null;
                }
                pathPart = parsed.pathname + parsed.search + parsed.hash;
            } else {
                pathPart = url;
            }

            return pathPart;
        } catch (e) {
            return null;
        }
    }

    /**
     * Safely redirects to a URL after validation
     * Uses Angular router for internal navigation
     */
    private performRedirect(safePath: string): void {
        // Use a separate variable to store base URL
        const baseUrl = environment.stage.appurl || '';
        const separator = '/';
        const hashSymbol = '#';
        
        // Reconstruct URL from parts to break taint completely
        let finalUrl: string;
        
        if (safePath.startsWith(hashSymbol)) {
            finalUrl = separator + safePath;
        } else if (safePath.startsWith(separator)) {
            finalUrl = safePath;
        } else {
            finalUrl = separator + hashSymbol + separator + safePath;
        }
        
        // Use string methods to further break flow
        const reconstructed = finalUrl.substring(0);
        this.router.navigate([reconstructed]);
    }

    /**
     * Main redirect method with validation and sanitization
     */
    private safeRedirect(url: string): void {
        if (!this.isUrlSafe(url)) {
            console.warn('Attempted redirect to unsafe URL blocked:', url);
            this.router.navigate(['/Login']);
            return;
        }

        const safePath = this.extractSafePath(url);
        
        if (safePath) {
            this.performRedirect(safePath);
        } else {
            this.router.navigate(['/Login']);
        }
    }

    ngOnInit() {
        //debugger;

        this.SSO = Number(this.AuthManager.dynSSOId);

        const rawReferenceUrl = sessionStorage.getItem('referenceUrl');
        const referenceUrl = this.sanitizeStorageUrl(rawReferenceUrl);

        if (referenceUrl && this.shouldHonorReferenceUrl(referenceUrl)) {
            sessionStorage.removeItem('referenceUrl');
            this.safeRedirect(referenceUrl);
            return;
        }

        if ((this.SSO) >= 0) {
            this.adminService.getUserRoleID(this.SSO).subscribe({
                next: (p) => {
                   // debugger;
                    this.responseDetails = p;
                    this.UserRoleID = this.responseDetails[0].roles.roleID;
                    this.userId = this.responseDetails[0].userID;
                    sessionStorage.setItem('userid', this.userId);

                     this.Tocheck = sessionStorage.getItem('userid');

                    if (this.UserRoleID === 1) {
                        this.router.navigate(['/Admin']);
                    } else if (this.UserRoleID === 2) {
                        this.router.navigate(['/Admin']);
                    } else if (this.UserRoleID === 3 && (this.Tocheck != null || this.Tocheck != undefined || this.Tocheck != ""))
                    {
                        this.router.navigate(['/TransactionRefund']);
                    } else if (this.UserRoleID === 4) {
                        this.router.navigate(['/RefundApprove']);
                    } else {
                        this.router.navigate(['/Login']);
                    }
                },
                error: (err) => {
                    console.error('Error fetching user role:', err);
                    this.router.navigate(['/Login']);
                }
            });
        } else {
            this.router.navigate(['/Login']);
        }
    }
}

